// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"770":"b0caadcb","849":"76827c02"}[chunkId] + ".chunk.css";
};